module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Fauteur de troubles")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("Par Rhys Ford")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("Série 415 Ink, Tome 3")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Quand l’inspecteur Ruan Nicholls rencontre Ivo Rogers, il sait immédiatement que ce jeune tatoueur va bouleverser sa vie bien rangée. Fauteur de troubles par nature, Ivo est quelqu’un que Ruan non seulement ne comprend pas, mais qu’il n’est pas sûr de vouloir comprendre. Tout chez Ivo est plein de vie, impétueux, prétentieux et arrogant, mais Ruan ne veut rien de lui.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ou du moins, c’est le mensonge qu’il se répète pour amoindrir le désir qu’il éprouve pour cet enfant terrible, issu des services sociaux, que le destin a placé au travers de sa route.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Deux choses importent dans la vie d’Ivo Rogers : sa famille et 415 Ink, le salon de tatouage qu’il a fondé avec ses quatre frères. Si sa famille porte encore des cicatrices après s’être battue contre les services sociaux pendant de nombreuses années, le lien qui existe entre eux est fort, assez pour soutenir Ivo dans les moments difficiles.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Mais voilà que ce dernier doit faire face à un nouveau défi quand il tombe amoureux d’un policier de la vieille école, qui a des idées reçues sur ce à quoi un homme doit ressembler. Ruan incarne la promesse d’une vie qu’Ivo n’aurait jamais pensé avoir un jour, mais leurs manières opposées de voir le monde menacent toute chance d’une relation entre eux. Il est facile d’être mal compris quand on est le fauteur de troubles de la famille, mais Ivo a confiance en Ruan : celui-ci saura accepter qui il est et l’aimer comme il le mérite.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Alignment__And__Left_Indent__And__Tabs"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b970d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0